<template>
  <div class="pagination">
    <template v-if="version === 1">
      <p class="text">
        You've viewed <b>{{ visibleProductCount }}</b> of
        <b>{{ productCount }}</b> products
      </p>
      <Button :loading="loading" @click="handleLoadMore">Load More</Button>
    </template>
    <template v-else-if="version === 2">
      <p class="text">{{ visibleProductCount }}/{{ productCount }}</p>
      <Button form="underline" @click="handleLoadMore">
        Load {{ PER_PAGE }} More
      </Button>
    </template>
    <template v-else-if="version === 3">
      <ScrollTrigger
        :disabled="loading"
        @intersected="handleLoadMore"
      ></ScrollTrigger>
    </template>
  </div>
</template>

<script>
import Button from "@/components/ButtonV2.vue";
import ScrollTrigger from "@/components/ScrollTrigger.vue";

import { getFeatureToggles } from "@/helpers/featureToggles";
import { mapGetters, mapState } from "vuex";
import { PER_PAGE } from "@/helpers/pagination";

export default {
  name: "Pagination",
  components: {
    Button,
    ScrollTrigger,
  },
  props: {
    forceVersion: {
      type: Number,
      default: null,
    },
  },
  emits: ["load-more"],
  data() {
    return {
      PER_PAGE,
    };
  },
  computed: {
    ...mapGetters("collection", ["productCount", "visibleProductCount"]),
    ...mapState("collection", ["loading"]),
    version() {
      if (this.forceVersion) return this.forceVersion;

      const { paginationVersion = 1 } = getFeatureToggles();
      return paginationVersion;
    },
  },
  methods: {
    handleLoadMore() {
      this.$emit("load-more");
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  padding: 40px 20px;
  text-align: center;

  @include respond-above(md) {
    padding: 60px 20px;
  }
}

.text {
  @include utility-label(14px);
  margin-bottom: 16px;
}
</style>
